export default __webpack_public_path__ + "static/media/video_placeholder_sm.75891d72.svg";